import axios from 'axios';
import * as CONSTANTS from "@/constants/constants";

let http = axios.create({
  baseURL: `${CONSTANTS.API_URL}/v2`,
  timeout: 20000
});

export default http;
